export enum MODAL_STATE {
  CREATING_REPORT = 'CREATING_REPORT',
  CREATED_REPORT = 'CREATED_REPORT',
}

export enum STATUS {
  NOT_STARTED = 'ยังไม่เริ่ม',
  IN_PROGRESS = 'กำลังสัมภาษณ์',
  COMPLETED = 'เสร็จแล้ว',
  OVERDUE = 'หมดอายุ',
  INCOMPLETE = 'สัมภาษณ์ไม่เสร็จ',
}
